import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';

ReactDOM.render(<App />, document.querySelector('#root'));



// WEBPACK FOOTER //
// ./src/index.js